export default class InvalidCecotecEmailError extends Error {
  code = 'InvalidCecotecEmailError';
  message = 'Solo pueden registrarse cuentas con email @cecotec.es';
}
